// extracted by mini-css-extract-plugin
module.exports = {"container":"JournalTeaser_container__4Pe30","mediaBlock":"JournalTeaser_mediaBlock__UDE6D"};